import styled, { css } from "styled-components";
import { atMinWidth, units } from "@m/alchemy-theme";
import { MOBILE_BREAKPOINT } from "../constants";
export const AppLogo = styled.div `
  display: ${({ shouldHideOnMobile }) => (shouldHideOnMobile ? "none" : "flex")};
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;

  svg {
    display: block;
  }

  ${atMinWidth(MOBILE_BREAKPOINT, css `
      display: flex;
      margin-right: ${units(5.5)};
    `)}
`;
